import React, { useEffect, useState } from "react";

import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import useSWR from "swr";

import {
  Route,
  Switch,
  useHistory,
  withRouter,
  useLocation,
  Redirect,
  matchPath,
} from "react-router-dom";
import Button from "@material-ui/core/Button";
import { useDispatch, useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { Hidden, useTheme } from "@material-ui/core";
import { Helmet } from "react-helmet";
import fetcher from "../../api/swr_fetcher";

function determineTokenType(token, tokenStatus, loginId) {
  if (token) {
    if (tokenStatus == 403) {
      return "BANNED";
    }
    if (tokenStatus == 401) return "TIMEOUT";
  } else {
    if (tokenStatus == 403) {
      return "NOT_AUTHENTICATED";
    }
    if (tokenStatus == 401) return "NOT_AUTHENTICATED";
  }
  return false;
}

export default function PrivateRoute({
  component: Component,
  path,
  kyc: propKyc,
  ...rest
}) {
  const dispatch = useDispatch();
  let history = useHistory();
  const location = useLocation();

  const tokenStatus = useSelector((state) => state.trading.TOKEN_STATUS);
  const token = useSelector((state) => state.trading.TOKEN);
  const loginId = useSelector((state) => state.trading.LOGIN_ID);
  const refreshPagePopup = useSelector(
    (state) => state.trading.REFRESH_PAGE_POPUP
  );

  const type = determineTokenType(token, tokenStatus, loginId);
  let olderWebsitePresent = sessionStorage.getItem("user") ? true : false;

  const findAuthProp = matchPath(location.pathname, {
    path: path,
    exact: true,
    strict: false,
  }).isExact;

  function getKYC() {
    fetcher(`/v1/um/getKycDetails`)
      .then((data) => {
        if (data.verified && data.status === "approved") {
          setKycDone(true);
        } else {
          handleClickOpen();
        }
      })
      .catch((err) => {
        handleClickOpen();
      });
  }

  function getBank() {
    fetcher(`/v1/um/bankAccount`)
      .then((data) => {
        if (data.status != "verified") {
          handleClickOpen();
        }
      })
      .catch((err) => {
        handleClickOpen();
      });
  }

  const [kycDone, setKycDone] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    getKYC();
    getBank();
  }, []);

  useEffect(() => {
    if (propKyc) {
      getKYC();
      getBank();
    }
  }, [location.pathname]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleDialogClose = () => {
    handleLogout();
    history.push({
      pathname: "/login",
      state: { redirectTo: location.pathname },
    });
  };

  const handleContactSupport = () => {
    handleLogout();
    history.push({
      pathname: "/login",
      state: { redirectTo: location.pathname },
    });

    setTimeout(() => {
      document.querySelector(
        "#fc_frame, #fc_frame.fc-widget-normal"
      ).style.display = "block";
      window.fcWidget.open();
      window.fcWidget.show();
    }, 200);
  };

  function handleLogout() {
    dispatch({ type: "SET_TOKEN", payload: null });
    dispatch({ type: "SET_TOKEN_STATUS", payload: null });
    dispatch({ type: "SET_LOGIN_ID", payload: null });

    window.fcWidget.user.clear();
  }

  return (
    <>
      {olderWebsitePresent ? (
        <Dialog
          disableBackdropClick
          open={true}
          onClose={handleDialogClose}
          style={{ minHeight: "500px" }}
        >
          <DialogTitle>Website upgraded! 🎉</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              We have rolled out some important updates to our website. Kindly
              sign in again to continue.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            style={{ paddingBottom: "30px", paddingRight: "20px" }}
          >
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                sessionStorage.removeItem("user");
                handleLogout();
                history.push({
                  pathname: "/login",
                  state: { redirectTo: location.pathname },
                });
              }}
              style={{ color: "white", fontWeight: "bold" }}
            >
              Sign In
            </Button>
          </DialogActions>
        </Dialog>
      ) : Boolean(type) && type != "NOT_AUTHENTICATED" ? (
        <Dialog
          disableBackdropClick
          open={Boolean(type)}
          onClose={handleDialogClose}
          style={{ minHeight: "500px" }}
        >
          <DialogTitle>
            {type === "BANNED"
              ? `Your account is under review. Please contact Support.`
              : `Session timed out, please login again to continue`}
          </DialogTitle>
          <DialogActions
            style={{ paddingBottom: "30px", paddingRight: "20px" }}
          >
            {type === "BANNED" ? (
              <>
                <Button
                  variant="outlined"
                  onClick={handleContactSupport}
                  color="primary"
                  style={{ fontWeight: "bold" }}
                >
                  Contact Support
                </Button>{" "}
                <Button
                  variant="contained"
                  color="primary"
                  onClick={handleDialogClose}
                  style={{ color: "white", fontWeight: "bold" }}
                >
                  Ok
                </Button>
              </>
            ) : (
              <>
                <Button
                  variant="outlined"
                  onClick={handleDialogClose}
                  color="primary"
                  style={{ fontWeight: "bold" }}
                >
                  Login
                </Button>
                <Button
                  variant="outlined"
                  onClick={() => {
                    handleLogout();
                    history.push("/trade/BTC");
                  }}
                  color="primary"
                  style={{ fontWeight: "bold" }}
                >
                  Close
                </Button>
              </>
            )}
          </DialogActions>
        </Dialog>
      ) : findAuthProp && !token && !rest.authenticationNotNeeded ? (
        <Dialog
          disableBackdropClick
          open={true}
          onClose={handleDialogClose}
          style={{ minHeight: "500px" }}
        >
          <DialogTitle>
            Please register or sign in to view this page.
          </DialogTitle>
          <DialogActions
            style={{ paddingBottom: "30px", paddingRight: "20px" }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                handleLogout();
                history.push("/createacc");
              }}
              color="primary"
              style={{ fontWeight: "bold" }}
            >
              Register
            </Button>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                handleLogout();
                history.push({
                  pathname: "/login",
                  state: { redirectTo: location.pathname },
                });
              }}
              style={{ color: "white", fontWeight: "bold" }}
            >
              Sign In
            </Button>
          </DialogActions>
        </Dialog>
      ) : open && propKyc ? (
        <Dialog
          disableBackdropClick
          open={open}
          onClose={handleClose}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{ marginTop: "15px" }}>
            {kycDone
              ? "Add Bank Account to Deposit/Withdraw INR"
              : "Complete your KYC to Deposit/Withdraw INR"}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              {kycDone
                ? `You will need to verify your bank accouny details to deposit and
              withdraw INR. Click on the button below to verify the bank account
              you will use for Deposit/Withdraw of INR.`
                : `You will need to verify KYC details to deposit and
              withdraw INR. Click on the button below to verify KYC details.`}
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Hidden smDown>
              <Button
                onClick={() => {
                  // updateDrawer(Date.now());
                  if (kycDone) {
                    history.push(`/accsettings?tab=1`);
                  } else {
                    history.push(`/accsettings`);
                  }
                }}
                color="primary"
                variant="contained"
                style={{ color: "white", fontWeight: "bold", margin: "20px" }}
              >
                {kycDone ? "Add Bank Account" : "Complete KYC verification"}
              </Button>
            </Hidden>
            <Hidden mdUp>
              <Button
                onClick={() => {
                  // updateDrawer(Date.now());
                  if (kycDone) {
                    history.push(`/bank`);
                  } else {
                    history.push(`/onboarding`);
                  }
                }}
                color="primary"
                variant="contained"
                style={{ color: "white", fontWeight: "bold", margin: "20px" }}
              >
                {kycDone ? "Add Bank Account" : "Complete KYC verification"}
              </Button>
            </Hidden>
          </DialogActions>
        </Dialog>
      ) : (
        <Route {...rest} render={(props) => <Component {...props} />} />
      )}
    </>
  );
}

function RefreshPopup(props) {
  return (
    <Dialog
      disableBackdropClick
      open={props.open}
      style={{ minHeight: "500px" }}
    >
      <DialogTitle>PocketBits updated! 🎉</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {props.data}
        </DialogContentText>
      </DialogContent>
      <DialogActions style={{ paddingBottom: "30px", paddingRight: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            window.location.reload();
          }}
          style={{ color: "white", fontWeight: "bold" }}
        >
          Refresh
        </Button>
      </DialogActions>
    </Dialog>
  );
}
